<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('all_notification')" icon="bell"/>
            </div>
        </div>

        <app-table :id="tableId" :options="options" @action="triggerActions"/>

    </div>
</template>

<script>
import * as actions from '../../../../Config/ApiUrl'
import AppLibrary from "../../../../Helpers/AppLibrary";
import {formatDateToLocal, onlyTime, optional} from "../../../../Helpers/Helpers";
import {axiosPost} from "../../../../Helpers/AxiosHelper";
import {MANAGE_NOTIFICATION_ALL} from "../../../../Config/ApiUrl";

export default {
    name: "AllNotification",
    extends: AppLibrary,
    data() {
        return {
            selectedUrl: '',
            tableId: 'all-notifications',
            rowData: {},
            options: {
                name: 'All Notifications',
                url: actions.NOTIFICATIONS_LIST,
                showHeader: true,
                columns: [
                    {
                        title: this.$t('date'),
                        type: 'object',
                        key: 'created_at',
                        uniqueKey: 'id',
                        modifier: function (created_at, row) {
                            return created_at;
                        }
                    },
                    /*{
                        title: this.$t('time'),
                        type: 'object',
                        key: 'created_at',
                        uniqueKey: 'id',
                        modifier: function (created_at, row) {
                            return onlyTime(formatDateToLocal(created_at, true))
                        }
                    },*/
                    {
                        title: this.$t('title'),
                        type: 'custom-html',
                        key: 'user_notification',
                        modifier: (value, row) => {
                            if (value != null && value.name !== null) {
                                return value.name;
                            }
                            return '-';
                        }
                    },
                    {
                        title: this.$t('gameid'),
                        type: 'custom-html',
                        key: 'game_id',
                        modifier: (value, row) => {
                            return '<a href="/game/' + value + '" target="_blank">' + value + '</a>';
                        }
                    },
                    {
                        title: this.$t('time'),
                        type: 'custom-html',
                        key: 'game',
                        modifier: (value, row) => {
                            if (value != null && value.event_start_time !== null) {
                                return value.event_start_time;
                            }
                            return '';
                        }
                    },
                    {
                        title: this.$t('sport'),
                        type: 'text',
                        key: 'sport',
                    },
                    {
                        title: this.$t('team_1'),
                        type: 'custom-html',
                        key: 'game',
                        modifier: (value, row) => {
                            if (value != null && value.team1 !== null) {
                                return '<a href="/team/' + value.team_1_id + '" target="_blank" class="hidden-link">' + value.team1 + '</a>';
                            }
                            return '-';
                        }
                    },
                    {
                        title: this.$t('team_2'),
                        type: 'custom-html',
                        key: 'game',
                        modifier: (value, row) => {
                            if (value != null && value.team2 !== null) {
                                return '<a href="/team/' + value.team_2_id + '" target="_blank" class="hidden-link">' + value.team2 + '</a>';
                            }
                            return '-';
                        }
                    },
                    {
                        title: this.$t('league'),
                        type: 'custom-html',
                        key: 'game',
                        modifier: (value, row) => {
                            if (value != null && value.league !== null) {
                                return '<a href="/league/' + value.league_id + '" target="_blank" class="hidden-link">' + value.league + '</a>';
                            }
                            return '-';
                        }
                    },
                    {
                        title: this.$t('changes'),
                        type: 'custom-html',
                        key: 'changes',
                        style: 'min-width: 160px',
                        modifier: (value, row) => {
                            let changes = '';
                            if (value != null && typeof value !== 'undefined') {
                                for (let i = 0; i < value.length; i++) {
                                    let change = value[i];
                                    let newVal = change.new;
                                    let oldVal = change.old;
                                    let side = change.side;
                                    let type = change.type;
                                    // difference with round
                                    let diff = Math.round((newVal - oldVal) * 100) / 100;
                                    let changeText = '<b style="color: #777;">' + this.$t(type) + ' - ' + this.$t(side) + ' ' + '</b><br>' + ' ' + oldVal + ' ' + this.$t('to') + ' ' + newVal + ' ';
                                    if (newVal > oldVal) {
                                        changeText += '<span class="text-success">+' + diff + '</span>';
                                    } else if (newVal < oldVal) {
                                        changeText += '<span class="text-danger">' + diff + '</span>';
                                    } else {
                                        changeText += '<span class="text-muted">0</span>';
                                    }
                                    changes += changeText + '<br>';
                                }
                            }
                            return changes;
                        }
                    },
                    {
                        title: this.$t('wdw'),
                        type: 'wdw',
                        key: 'wdw',

                    },
                    {
                        title: this.$t('asian_handicap'),
                        type: 'ah',
                        key: 'asian',

                    },
                    {
                        title: this.$t('over_under'),
                        type: 'ou',
                        key: 'totals',

                    },
                ],
                filters: [
                    {
                        "title": this.$t('created'),
                        "type": "range-picker",
                        "key": "date",
                        "option": ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        "title": this.$t('notification'),
                        "type": "multi-search-select-filter",
                        "key": "notification",
                        "url": actions.MANAGE_NOTIFICATION_ALL,
                    },
                    {
                        "title": this.$t('sport'),
                        "type": "checkbox",
                        "key": "sport",
                        "option": [
                            {id: 'football', value: 'Football'},
                            {id: 'basketball', value: 'Basketball'},
                            {id: 'tennis', value: 'Tennis'},
                        ],
                    },
                    {
                        "title": this.$t('wdw'),
                        "type": "odds-range-filter",
                        "key": "wdw",
                        "firstTitle": this.$t('home'),
                        "secondTitle": this.$t('draw'),
                        "thirdTitle": this.$t('away'),
                        "stakeTitle": this.$t('stake'),
                        "sign": ""
                    },
                    {
                        "title": this.$t('asian_handicap'),
                        "type": "odds-range-filter",
                        "key": "ah",
                        "firstTitle": this.$t('line'),
                        "secondTitle": this.$t('home'),
                        "thirdTitle": this.$t('away'),
                        "stakeTitle": this.$t('stake'),
                        "sign": ""
                    },
                    {
                        "title": this.$t('over_under'),
                        "type": "odds-range-filter",
                        "key": "total",
                        "firstTitle": this.$t('line'),
                        "secondTitle": this.$t('over'),
                        "thirdTitle": this.$t('under'),
                        "stakeTitle": this.$t('stake'),
                        "sign": ""
                    },
                    {
                        "title": this.$t('sort_by'),
                        "type": "checkbox",
                        "key": "sort_by",
                        "option": [
                            {id: 'id', value: 'ID'},
                            {id: 'date', value: 'Start time'},
                            {id: 'wdw_1', value: 'WDW Home'},
                            {id: 'wdw_2', value: 'WDW Draw'},
                            {id: 'wdw_3', value: 'WDW Away'},
                            {id: 'wdw_s', value: 'WDW Stake'},
                            {id: 'ah_1', value: 'AH Line'},
                            {id: 'ah_2', value: 'AH Home'},
                            {id: 'ah_3', value: 'AH Away'},
                            {id: 'ah_s', value: 'AH Stake'},
                            {id: 'ou_1', value: 'OU Line'},
                            {id: 'ou_2', value: 'OU Over'},
                            {id: 'ou_3', value: 'OU Under'},
                            {id: 'ou_s', value: 'OU Stake'},
                        ],
                    },
                    {
                        "title": this.$t('order_asc_desc'),
                        "type": "checkbox",
                        "key": "order",
                        "option": [
                            {id: 'asc', value: 'ASC'},
                            {id: 'desc', value: 'DESC'},
                        ],
                    },
                    {
                        "title": this.$t('search_leagues'),
                        "type": "multi-search-select-filter",
                        "key": "league",
                        "url": actions.LEAGUES_LIST,
                    },
                ],
                showFilter: true,
                showSearch: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 50,
                showAction: false,
                orderBy: 'desc',
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t('copy'),
                        icon: 'copy',
                        type: 'page',
                        url: `/`,
                        name: 'copy'
                    }
                ],
            }
        }
    },

    methods: {
        triggerActions(row, action, active) {
            this.readNotification(row);
        },
        readNotification(notification) {
            axiosPost(`admin/user/notifications/mark-as-read/${notification.id}`).then(({data}) => {
                if (data.data.url) {
                    window.location = data.data.url;
                }
            });
        },
    }
}
</script>
